// The meeting in its own always-on-top window (Document Picture-in-Picture: Chrome / Edge). The call keeps running in
// this tab; React renders the window's content through a portal, so nothing reconnects when it opens or closes.
import { useCallback, useEffect, useState } from 'react';

export const popoutSupported = () => typeof window !== 'undefined' && 'documentPictureInPicture' in window;

export function usePopout(title) {
  const [win, setWin] = useState(null);
  const [width, setWidth] = useState(0);

  const open = useCallback(async () => {
    if (!popoutSupported()) return false;
    try {
      const w = await window.documentPictureInPicture.requestWindow({ width: 720, height: 480 });
      document.querySelectorAll('link[rel="stylesheet"], style').forEach((n) => w.document.head.appendChild(n.cloneNode(true)));
      w.document.title = title || 'Team Meeting';
      Object.assign(w.document.body.style, { margin: '0', background: '#0D1B2A', overflow: 'hidden' });
      const root = w.document.createElement('div');
      root.style.height = '100vh';
      w.document.body.appendChild(root);
      w.addEventListener('pagehide', () => setWin(null), { once: true });
      w.addEventListener('resize', () => setWidth(w.innerWidth));
      setWidth(w.innerWidth);
      setWin({ w, root });
      return true;
    } catch {
      return false;
    }
  }, [title]);

  const close = useCallback(() => setWin((cur) => { try { cur?.w.close(); } catch { /* gone */ } return null; }), []);

  useEffect(() => () => { try { win?.w.close(); } catch { /* gone */ } }, [win]);

  return { supported: popoutSupported(), root: win?.root || null, width, open, close };
}
